import React from 'react';

import { CardComponent } from '../CardComponent';


export function IpAccess(props) {
  const { isLoading, modalBankName, setAddIpModal, addIpModal, ipAddress, ipAddressHandleOnChange, saveIpRestrictionModal, ipRestriction, removeIpRestriction, closeIPModal } = props;


  return (
    <CardComponent
      title={modalBankName}
      titleStyles={{ display: 'inline-block', fontSize: '2.6rem', fontWeight: 400, marginLeft: '30px', marginTop: '20px' }}
      styles={{ position: 'fixed', top: '15%', left: '20%', zIndex: 1050, background: 'white', maxHeight: '600px', width: '500px', overflow: 'scroll', border: 'solid grey', borderRadius: '10px' }}
      isLoading={isLoading}
      disableCardBackgroundColor
    >
      <div style={{ marginLeft: '25px', marginRight: '15px', marginBottom: '20px' }}>
        <form>
          <div>
            <div className="row">
              <div className=" col s12 m8">
                <h3 id="ipProjectName"></h3>
              </div>
              <div className="row" style={{ float: 'right' }}>
                <a className="waves-effect waves-light btn right"
                  onClick={() => { setAddIpModal(true) }}
                >
                  ADD
                </a>
                <a style={{ marginBottom: '10px', marginRight: '10px' }}
                  onClick={closeIPModal}
                  className="btn btn-white"
                >
                  Close
                </a>
              </div>
            </div>
            <div className="row">
              <div style={{ color: '#505050', fontWeight: 'bold' }}>IP mask 0.0.0.0/0 will allow all traffic.</div>
            </div>
            <div className="row">
              {addIpModal ?
                <div className="col s12 m8" style={{ marginBottom: '20px' }}>
                  <div data-error="Please use a format like: 0.0.0.0/0" style={{ marginBottom: '1px' }}>
                    IP Mask
                  </div>
                  <input className="validate"
                    type="text"
                    value={ipAddress}
                    onChange={ipAddressHandleOnChange}
                    pattern="^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))$"
                    style={{ marginRight: '200px' }}
                  />
                  <a onClick={() => { saveIpRestrictionModal() }} className="btn btn-primary" style={{ marginRight: '10px' }}>Save</a>
                  <a onClick={() => { setAddIpModal(false) }} className="btn btn-secondary">Cancel</a>
                </div>
                : ''}
            </div>
            <div className="row">
              <div>
                {ipRestriction.map(function (data, index) {
                  return (data.id) ?
                    <div key={index}>
                      <div className="col s12 m8">
                        <div data-error="Please use a format like: 0.0.0.0/0" style={{ marginBottom: '1px' }}
                        >
                          IP Mask
                        </div>
                        <div id={data.id} style={{ borderBottom: "1px solid black" }}>
                          <a style={{ marginLeft: '6px', color: 'black' }}>
                            {data.ipMask}
                          </a>
                        </div>
                      </div>
                      <div className="blacklight col s12 m4" style={{ marginTop: '24px' }}>
                        <a style={{ color: '#e42f2f !important', float: 'left', cursor: 'pointer' }}
                          onClick={() => {
                            const deleteIp = data.ipMask;
                            removeIpRestriction(deleteIp)
                          }}
                        >
                          <i className="h4 material-icons">delete</i>
                        </a>
                      </div>
                    </div>
                    : ''
                }
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </CardComponent>
  );
}
